<template>
    <div>
        <announcement-banner :banner="announcementBanner" />

        <!-- Organization splash page: admin-authored HTML (Admin > Splash Page). Shown instead of the
             program boxes to logged-out visitors; HomeController decides when this page is used. -->
        <section class="splash-content mx-4 mt-4 mb-8" v-html="splashPageHtml"></section>
    </div>
</template>

<script>
    export default {
        name: 'SplashPage',
        props: {
            orgSettings: {
                type: Object,
                default: () => null,
            },
            announcementBanner: {
                type: Object,
                default: () => null,
            },
            splashPage: {
                type: Object,
                default: () => null,
            },
        },
        computed: {
            // Quill adds target="_blank" to every link. Splash buttons like "Start" or
            // "Browse Programs" point inside the site, so open those in the same tab.
            // External links keep opening in a new tab.
            splashPageHtml() {
                if (!this.splashPage || !this.splashPage.html) {
                    return '';
                }
                const doc = new DOMParser().parseFromString(this.splashPage.html, 'text/html');
                // Splash content written before the programs moved to their own page links to
                // "#programs" (an anchor on the old combined page). Send those to /programs.
                doc.body.querySelectorAll('a[href="#programs"]').forEach(link => {
                    link.setAttribute('href', '/programs');
                });
                doc.body.querySelectorAll('a[target="_blank"]').forEach(link => {
                    // Resolve relative hrefs ("/area/1", "/programs") against this page and
                    // compare origins, so "//other-site.com" still counts as external.
                    const url = new URL(link.getAttribute('href') || '', window.location.href);
                    if (url.origin === window.location.origin) {
                        link.removeAttribute('target');
                    }
                });
                // Small brand label above the title ("Greenbush+"), from the organization's display
                // name so each tenant shows its own. Added into the HTML (not as a separate element)
                // so it sits inside the splash card. textContent keeps the name from being read as HTML.
                const brandName = this.orgSettings && (this.orgSettings.applicationDisplayName || this.orgSettings.name);
                if (brandName) {
                    const eyebrow = doc.createElement('p');
                    eyebrow.className = 'splash-eyebrow';
                    eyebrow.textContent = brandName;
                    doc.body.prepend(eyebrow);
                }
                return doc.body.innerHTML;
            },
        },
    };
</script>
